import React, { useState } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import { LOGS_DISPLAY_ACCOUNT_TYPES } from '@silverfort-nodelibs/common/utils/consts';

import styles from './LogsSettingsModal.module.css';
import { Dropdown } from '@silverfort/sf-components';

const LogsSettingsModal = ({ onApprove, onCancel, accountType, showInternalAuthLogs }) => {
    const [selectedAccountType, setSelectedAccountType] = useState(accountType);
    const [showInternalAuthLogsSelected, setShowInternalAuthLogsSelected] = useState(showInternalAuthLogs);

    const onAccountTypeChanged = (newValue) => {
        setSelectedAccountType(newValue);
    };

    const SaveConfigurationClicked = () => {
        onApprove(selectedAccountType, showInternalAuthLogsSelected);
    };

    const onShowInternalLogsClick = (checked) => {
        setShowInternalAuthLogsSelected(checked);
    };

    return (
        <Modal
            id={styles.logsSettingsModal}
            show={true}
            enforceFocus={false}
            className="z-[5000]"
            keyboard={true}
            backdropClassName="z-[900]"
            backdrop="static">
            <Modal.Header>
                <Modal.Title>Configure Logs</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <div className={`${styles.logsConfigurationField}`}>
                        <div className={styles.accountTypeFieldLabel}>Account identifier: </div>
                        <div className={styles.accountTypeFieldData}>
                            <div className={` ${styles.accountTypeSelector}`}>
                                <Dropdown
                                    items={Object.values(LOGS_DISPLAY_ACCOUNT_TYPES).map((option) => ({
                                        value: option.value,
                                        title: option.label,
                                        disabled: option.disabled
                                    }))}
                                    menuClassName="z-[1200]"
                                    selectedItems={selectedAccountType}
                                    variant="trigger"
                                    onChange={(value) => {
                                        onAccountTypeChanged(value);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="h-20 rounded-lg border border-gray-200 flex mt-12 mx-10 px-16 items-center">
                        <div className="checkbox">
                            <input
                                id="showInternalAuthLogs"
                                type="checkbox"
                                name="showInternalAuthLogs"
                                checked={showInternalAuthLogsSelected}
                                onChange={(e) => onShowInternalLogsClick(e.target.checked)}></input>
                            <label htmlFor="showInternalAuthLogs">
                                <div>Display Silverfort internal authentications</div>
                            </label>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className={styles.footerButtons}>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button bsStyle={'success'} onClick={SaveConfigurationClicked}>
                        Save
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default LogsSettingsModal;
